import { getOverviewBlockTabLabel, getOverviewBlockTitle } from '../../content';

export const OVERVIEW_CHART_TYPES = [
  { id: 'portfolio', label: getOverviewBlockTabLabel('portfolio', 'Value') },
  { id: 'incomeExpenses', label: getOverviewBlockTabLabel('incomeExpenses', 'Income') },
  { id: 'netCashflow', label: getOverviewBlockTabLabel('netCashflow', 'Returns') },
] as const;

export const OVERVIEW_VIEW_BY_OPTIONS = [
  { id: 'month', label: 'Monthly' },
  { id: 'year', label: 'Yearly' },
] as const;

export const OVERVIEW_DEFAULT_YEAR_OPTION = { id: 'all', label: 'All Time' } as const;

export type OverviewChartType = (typeof OVERVIEW_CHART_TYPES)[number]['id'];
export type OverviewViewBy = (typeof OVERVIEW_VIEW_BY_OPTIONS)[number]['id'];

export function getOverviewChartTitle(chart: OverviewChartType): string {
  return getOverviewBlockTitle(chart, chart);
}
